.form-stats {
    height: 498px;
    width: 200px;
    border-right: var(--border-hairline);
}
